import { render, staticRenderFns } from "./TabInfosGenerales.vue?vue&type=template&id=27eba7d0"
import script from "./TabInfosGenerales.vue?vue&type=script&lang=js"
export * from "./TabInfosGenerales.vue?vue&type=script&lang=js"
import style0 from "./TabInfosGenerales.vue?vue&type=style&index=0&id=27eba7d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports